const values = {
    AUTH_TOKEN: 'auth_token',
    TWOFA_TOKEN: '2fa_token',
    LITERALS: 'fm_literals',
    PERMISSIONS: 'permissions',
};

export default class CacheManager {
    constructor(store) {
        this.store = store;
        this.listeners = {};
    }

    keys = () => values;

    set = (key, data) => {
        this.store.setItem(key, JSON.stringify(data));
    };

    get = (key) => JSON.parse(this.store.getItem(key));

    remove = (key) => {
        this.store.removeItem(key);
    };

    getTokenStore = () => this.get(values.AUTH_TOKEN);

    setTokenStore = (token) => {
        this.set(values.AUTH_TOKEN, token);
        this.notify(values.AUTH_TOKEN, token);
    };

    removeTokenStore = () => {
        this.remove(values.AUTH_TOKEN);
    };

    getLiteralsStore = () => this.get(values.LITERALS);

    setLiteralsStore = (data) => {
        this.set(values.LITERALS, data);
    };

    setPermissionsStore = (data) => {
        this.set(values.PERMISSIONS, data);
    };

    getPermissionsStore = () => this.get(values.PERMISSIONS);

    removeLiteralsStore = () => {
        this.remove(values.LITERALS);
    };

    updateLiterals = (key, data) => {
        const literals = this.getLiteralsStore();
        literals[key] = data[key];
        this.setLiteralsStore(literals);
        return literals;
    };

    clear = () => {
        this.removeLiteralsStore();
        this.removeTokenStore();
    };

    getListener = (store) => {
        if (!this.listeners[store]) {
            this.listeners[store] = [];
        }
        return this.listeners[store];
    };

    setListener = (store, func) => {
        const listener = this.getListener(store);
        const index = listener.indexOf(func);
        if (index === -1) {
            listener.push(func);
        }
    };

    clearListener = (func) => {
        let listener = this.getListener(this.store);
        const index = listener.indexOf(func);
        if (index !== -1) {
            listener = listener.splice(1, index, func);
        }
    };

    notify = (store, object) => {
        const listener = this.getListener(store);
        listener.forEach((listenerFunc) => {
            listenerFunc(object);
        });
    };
}
